// import React from 'react'
import { connect } from 'react-redux'
import { Debug } from 'components/debug'

const ModelDebug = connect((state, { model, pk }) => model.getItem(pk)(state))(
  Debug,
)
export default ModelDebug
